import { configureStore } from '@reduxjs/toolkit'
import drawerRightReducer from './slices/Drawer/drawerRight'
import drawerLeftReducer from './slices/Drawer/drawerLeft'
import modalConfirmation from './slices/Modal/modalBoxConfirmation'
import modalCodeQRReducer from './slices/Modal/modalCodeQR'
import modalDeleteRecReducer from './slices/Modal/modalDeleteRecord'
import enableButton from './slices/Modal/enableButton'
import treeFeaturesReducer from './slices/Tree/treeFeatures'
import mapStateReducer from './slices/Map/map'
import loginReducer from './slices/Auth/login'
import filterSearchReducer from './slices/Search/input'
import reportReducer from './slices/Report/reportSlice'
import alertsReducer from './slices/Alerts'
import serverStatusReducer from './slices/ServerStatusSlice'
import welcomeReducer from './slices/Welcome/welcomeSlice'
import notificationsReducer from './slices/Notifications/notificationsSlice'

export const store = configureStore({
  reducer: {
    drawerRight: drawerRightReducer,
    drawerLeft: drawerLeftReducer,
    modalConfirmation: modalConfirmation,
    modalRemoveTree: modalDeleteRecReducer,
    enableButton: enableButton,
    modalCodeQr: modalCodeQRReducer,
    treeFeatures: treeFeaturesReducer,
    mapState: mapStateReducer,
    login: loginReducer,
    filterSearch: filterSearchReducer,
    report: reportReducer,
    alertsGlobal: alertsReducer,
    serverStatus: serverStatusReducer,
    welcome: welcomeReducer,
    notifications: notificationsReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false, // desactiva advertencias por datos no serializables
    }),
  devTools: {
    trace: false,
    shouldRecordChanges: false,
    shouldCatchErrors: true,
    actionsDenylist: ['treeFeatures/features'], // evita log de acciones pesadas
    stateSanitizer: state => ({
      ...state,
      treeFeatures: {
        ...state.treeFeatures,
        data: {
          type: 'FeatureCollection',
          features: `🔒 ${state.treeFeatures?.data?.features?.length || 0} features`,
        },
      },
      login: {
        ...state.login,
        username: state.login?.username ? '🔒 oculto' : null,
        authenticated: state.login?.authenticated ? '🔒 true' : '🔒 false',
      },
    }),
  },
})
